import React from "react";
import { ContentTable } from "./ContentTable";
import { formatNumber } from "utils/currencyFormat";
import PhanTrang from "components/CommonComponent/PhanTrang";

export const TableDanhSachTrichLap = ({
  dataDanhSach,
  dataSearch,
  setDataSearch,
  onSearch,
  handlePageChange,
  handlePageSizeChange,
}) => {
  const TotalQuantity = dataDanhSach.TotalQuantity;
  return (
    <>
      <div
        className="card border-light mb-3 card-v2"
        style={{
          marginLeft: "15px",
          marginRight: "15px",
        }}
      >
        <div className="card-body card-body-v2">
          <div className="Left808x200 Table-main-new">
            <div className="table-mobile  table-mobile-hover table-responsive-new ">
              <div className="custom-table-wrapper">
                <div
                  className="table-headers"
                  style={{
                    position: "sticky",
                    padding: "2px",
                    top: "0rem",
                    zIndex: "999",
                    background: "#FFFFFF",
                    padding: "1px 0",
                  }}
                >
                  <div className="custom-table-header flex-basis-5 flex-basis-5-sm">
                    <p className="text-center">
                      STT
                      <br />{" "}
                      <span className="color-do-bold">
                        [ {dataDanhSach.TotalQuantity} ]
                      </span>
                    </p>
                  </div>
                  <div className="custom-table-header flex-basis-15 flex-basis-15-sm">
                    <p className="tab-header  text-center">Mã phiếu</p>
                  </div>
                  <div className="custom-table-header flex-basis-15 flex-basis-15-sm">
                    <p className="text-center">Ngày</p>
                  </div>
                  <div className="custom-table-header flex-basis-15 flex-basis-15-sm">
                    <p className="text-left">Nhân viên</p>
                  </div>
                  <div className="custom-table-header flex-basis-20 flex-basis-20-sm">
                    <p className="text-left">Ghi chú</p>
                  </div>
                  <div className="custom-table-header flex-basis-15 flex-basis-15-sm">
                    <p className="text-right">
                      Chi trích lập
                      <br />
                      <span className="color-do-bold text-right">
                        {formatNumber(dataDanhSach.TotalTienChi)}
                      </span>
                    </p>
                  </div>
                  <div className="custom-table-header flex-basis-15 flex-basis-15-sm">
                    <p className="text-right">Thu trích lập</p>
                    <span className="color-xanh-bold text-right">
                      {formatNumber(dataDanhSach.TotalTienThu)}
                    </span>
                  </div>
                </div>

                <div className="custom-table-body">
                  {dataDanhSach != undefined && (
                    <ContentTable listDataDanhSach={dataDanhSach.DanhSach} />
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        className="card mb-3 border-light mb-1 card-v2"
        style={{
          marginLeft: "15px",
          marginRight: "15px",
        }}
      >
        <div className="card-body card-body-v2">
          <PhanTrang
            pageIndex={dataSearch.pageIndex}
            pageSize={dataSearch.pageSize}
            totalCount={TotalQuantity}
            onPageChange={handlePageChange}
            onPageSizeChange={handlePageSizeChange}
          />
        </div>
      </div>
    </>
  );
};
